import { render } from "./product-gallery-modal.vue?vue&type=template&id=df738db8"
import script from "./product-gallery-modal.vue?vue&type=script&lang=js"
export * from "./product-gallery-modal.vue?vue&type=script&lang=js"

import "./product-gallery-modal.vue?vue&type=style&index=0&id=df738db8&lang=scss"

import exportComponent from "/Users/bornasepic/Desktop/projects/grau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__